//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueModal from '~/components/common/VueModal'
import ApplicationFormSection from '~/components/common/section/ApplicationFormSection'
export default {
  name: 'Modals',
  components: {
    VueModal,
    ApplicationFormSection,
  },
  data() {
    return {
      signupCoursesParams: {},
      mathCourseParams: {},
      modalThanksSettings: {
        firstTitle: this.$t('modals.congratulations'),
        secondTitle: this.$t('modals.offer'),
      },
      courseSettings: [
        {
          title: 'Default title',
          points: [],
        },
        {
          title: 'Default title 2',
          points: [],
        },
      ],
    }
  },
  methods: {
    onBeforeOpen(event) {
      this.mathCourseParams = event.params
    },
    onBeforeOpenSignupCourses(event) {
      this.signupCoursesParams = event.params
    },
    onMathFormSubmitted(index) {
      this.$modal.hide('modal-course-0' + index)
    },
  },
}
